<template>
  <div class="data_brain_wrap">
    <div class="brain_title">萬知發展歷程</div>
    <div class="brain_desc">數智賦能、高效協同，助力實現産業高質量發展</div>

    <el-row class="card_wrap" type="flex">
      <el-col
        class="brain_item"
        :lg="7"
        :sm="11"
        :xs="11"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="item_title">{{ item.title }}</div>
        <div class="item_desc">{{ item.desc }}</div>
        <!-- <div class="item_navigate" @click="handleNavigate">了解详情 >></div> -->
        <div class="item_bg"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          title: "創立初期",
          desc:
            "陝西知禪信息技術有限公司創立了萬知網，初步搭建起知識産權服務平臺，确定以商標服務、專利服務、版權服務、科技項目服務等為核心業務"
        },
        {
          title: "模式探索",
          desc:
            "積極探索互聯網技術與知識産權服務融合，建立起標準化的知識産權服務流程和規範，實現案件智能化管理和進度信息實時推送，解決行業資源配置等問題。"
        },
        {
          title: "模式形成",
          desc:
            "首創 “知識産權大數據共享經濟” 運營模式，依託萬知雲知識産權管理系統、萬知共享獨立商城系統、萬知數據交互系統、萬知深度檢索分析服務系統等四大服務體繫，為各類主體提供知識産權資源運營解決方案。"
        },
        {
          title: "資源整合",
          desc:
            "全方位、多維度、實時動態的産業數據展示和分析。憑借平臺優勢，吸引了多家知名資源采購企業及平臺入駐，積累了海量高品質資源"
        },
        {
          title: "合作拓展",
          desc:
            "與海內外十多家科硏機構達成戰略合作，構建起完整的知識産權資源流通産業鏈"
        },
        {
          title: "創新發展階段",
          desc:
            "開拓性地創建 “知識産權城市合夥人” 運作機制，在省會城市、直轄市、國家新三綫城市開展 “萬知 DNA 區塊鏈” 復制工程，聯合更多知識産權相關企業、機構和行業，形成高效高能的 IP 矩陣立體互聯供需輸送及部署渠道"
        }
      ]
    };
  },
  methods: {
    handleNavigate() {
      this.$router.push("/production/1").catch(v => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 50px 0;
  background: #e8eef2;
  text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40px;
    }
  }
  .card_wrap {
    width: 70%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40px;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        &:nth-child(-n + 2) {
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg {
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110px;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100px;
        height: 30px;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/todo_show/index.vue